import { Card, CardBody, CardImg } from "reactstrap";
import { SaveIcon } from "../../assets/designedPickedIcons";
import { FaStar } from "react-icons/fa";
import { TiLocation } from "react-icons/ti";
import { RiDirectionLine } from "react-icons/ri";

const MostRecentSavedCard2 = ({ details }) => {
  return (
    <Card
      style={{ background: "rgba(248, 248, 248, 1)", borderRadius: "15.34px" }}
      className="position-relative full-height border-none figma-shadow-2 overflow-hidden "
    >
      <div
        style={{ height: 47, width: 47, right: 10, top: 11 }}
        className="bg-white position-absolute badge p-0 full-rounded color-primary-yellow-1 d-flex align-items-center justify-content-center"
      >
        <SaveIcon />
      </div>
      <CardImg
        style={{ borderRadius: "10.92px" }}
        src={details?.photos?.[0]}
        height={182}
        className="object-fit-cover"
      />
      <CardBody className="padding-left-18px  padding-right-15px">
        <div className="d-flex align-items-center justify-content-between ">
          <h4 className="f-6 m-0 baloo-font">{details?.name}</h4>
          <h4 className="color-primary-yellow-1 m-0 baloo-font">
            {details?.isOpen ? "Open" : "Closed"}
          </h4>
        </div>
        <h4 className=" baloo-font color-half-black-3 mb-1 f-4">
          {details?.types?.[0]}
        </h4>
        <div className="d-flex justify-content-between flex-wrap align-items-center margin-bottom-6px ">
          <h5 className="f-4 baloo-font color-primary-black-9 m-0">
            {details?.reviews?.length}
          </h5>
          <div className="d-flex align-items-center gap-5_1px">
            <h5 className="color-primary-black-9 m-0 baloo-font">
              {details?.totalReviews ?? 0}
            </h5>
            <FaStar size={20} color="rgba(246, 201, 68, 1)" />
          </div>
          <h5 className="color-primary-black-9 baloo-font m-0">25 minutes</h5>
        </div>
        <div className="d-flex align-items-center gap-1 mt-2 mb-3 ">
          <div>
            <TiLocation size={24} color="rgba(6, 84, 60, 1)" />
          </div>
          <h5 className="color-primary-black-9 f-4 m-0 baloo-font">
            {details?.location?.streetAddress}
          </h5>
        </div>
        <div className="d-flex color-primary-green-4 full-width align-items-center justify-content-end gap-0_4rem">
          <div>
            <RiDirectionLine size={25} />
          </div>
          <h5 className="m-0 color-primary-green-4 urbanist-font f-6">
            Directions
          </h5>
        </div>
      </CardBody>
    </Card>
  );
};

export default MostRecentSavedCard2;
